import axios from "axios";

//POST REQEUSTS
export const ghl_auth = async (payload) => {
    try {
        let options = {
            method: "POST",
            url: `https://us-central1-ghl-integration-embedded-app.cloudfunctions.net/ghl_auth_v2`,
            // url: `https://3779c5fcaddd.ngrok-free.app/path/ghl_auth`,
            data: payload
        }
        const result = await axios(options);
        return result;
    } catch (error) {
        console.log(error);
        throw error;
    }
}